class ComponentFacets extends HTMLElement {
  constructor() {
    super();
    this.initialize();
  }

  initialize() {
    this.activeFilters = {};

    this.data = {
      url: this.dataset.url,
    };

    this.elements = {
      filters: this.querySelectorAll("[id^='Filter']"),
      form: this.querySelector("[id^='Facets-Form']"),
      clearButton: this.querySelector("[id^='Facets-Button-Clear']"),
    };

    if (this.elements.clearButton) {
      this.elements.clearButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.resetFilters();
      });
    }

    this.setupFilters();
  }

  setupFilters() {
    this.elements.filters.forEach((filter) => {
      filter.addEventListener("change", () => {
        this.updateFilter(filter);
      });
    });

    this.setupActiveFilters();
  }

  updateFilter(filter) {
    const { name, value, checked } = filter;

    if (checked) {
      if (this.activeFilters[name] === undefined) {
        this.activeFilters[name] = [value];
      } else {
        this.activeFilters[name].push(value);
      }
    } else {
      if (this.activeFilters[name] !== undefined) {
        this.activeFilters[name].splice(
          this.activeFilters[name].indexOf(value),
          1
        );
      } else {
        this.activeFilters[name] = [];
      }
    }

    this.updateUrl();
  }

  setupActiveFilters() {
    this.activeFilters = {};

    this.elements.filters.forEach((filter) => {
      const { name, value, checked } = filter;

      if (checked) {
        if (this.activeFilters[name] === undefined) {
          this.activeFilters[name] = [value];
        } else {
          this.activeFilters[name].push(value);
        }
      }
    });
  }

  updateUrl() {
    // url is /collections/all
    // filter should be /collections/all/q?=search+tertm&filter_key=filter+value&filter_key=filter+value

    let url = this.data.url;

    if (Object.keys(this.activeFilters).length > 0) {
      url += "?";

      Object.keys(this.activeFilters).forEach((key, index) => {
        if (index > 0) {
          url += "&";
        }

        this.activeFilters[key].forEach((value, index) => {
          if (index > 0) {
            url += "&";
          }

          // replace spaces with + and & with %26
          url += `${key}=${value.replace(/ /g, "+").replace(/&/g, "%26")}`;
        });
      });
    }

    this.dispatchEvent(
      new CustomEvent("updateFacets", {
        detail: {
          url,
        },
      })
    );

    this.disableFilters();
  }

  resetForm(form) {
    this.elements.form.innerHTML = form.innerHTML;
    this.elements.filters = this.querySelectorAll("[id^='Filter']");
    this.elements.clearButton = this.querySelector(
      "[id^='Facets-Button-Clear']"
    );
    this.setupFilters();
    this.enableFilters();

    if (this.elements.clearButton) {
      this.elements.clearButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.resetFilters();
      });
    }
  }

  resetFilters() {
    this.dispatchEvent(
      new CustomEvent("updateFacets", {
        detail: {
          url: this.data.url,
        },
      })
    );
  }

  disableFilters() {
    this.classList.add("is-loading");
  }

  enableFilters() {
    this.classList.remove("is-loading");
  }
}

if (window.customElements.get("component-facets") === undefined) {
  window.customElements.define("component-facets", ComponentFacets);
}
